<template>
  <div v-if="wallet">
    <div v-if="showLoader" class="payment-iframe">
      <InlineLoader></InlineLoader>
    </div>
    <h3>Balance: {{ wallet.balance.amount }} {{ wallet.balance.currency }}</h3>
    <p v-if="!showLoader" class="billing-portal-link">
      <a
        :href="billingPortalLink"
        target="_blank"
        @click="onBillingPortalLinkClick"
      >
        Update your billing information
      </a>
    </p>
  </div>
</template>

<script>
import { HapiService } from "@/core/services/hapi.service";
import InlineLoader from "@/view/content/InlineLoader";
import CurrencyMixin from "@/view/mixins/CurrencyMixin";
import UserInfoMixin from "@/view/mixins/UserInfoMixin";

export default {
  name: "Wallet",
  mixins: [CurrencyMixin, UserInfoMixin],
  props: {
    amount: [String, Number]
  },
  emits: ["wallet-update"],
  components: {
    InlineLoader
  },
  data() {
    return {
      pWallet: null,
      products: [],
      displayOptions: {},
      billingPortalLink: "",
      fetchingWallet: false,
      loadingLink: false,
      showLoader: false
    };
  },
  computed: {
    wallet: {
      get: function() {
        return this.pWallet;
      },
      set: function(newValue) {
        this.pWallet = newValue;
        this.$emit("wallet-update", this.pWallet);
      }
    }
  },
  methods: {
    async fetchWallet() {
      this.fetchingWallet = true;
      let walletRequest;
      try {
        walletRequest = await HapiService.getWallet();
      } catch (error) {
        console.log("error fetching wallet", error);
        try {
          walletRequest = await HapiService.createWallet(this.selectedCurrency);
          this.fetchUserWallet();
        } catch (error) {
          console.log("error fetching wallet", error);
          return;
        }
      }
      const wallet = walletRequest
        ? this.normalizeWalletResponse(walletRequest.data)
        : null;

      this.fetchingWallet = false;
      console.log;

      if (wallet) {
        const transformedWallet = {
          id: wallet.id,
          hasBillingDetails: wallet.has_billing_details,
          createdDate: wallet.created_date,
          balance: wallet.balance
        };
        this.wallet = transformedWallet;
        await this.fetchBillingPortalLink();
        return this.wallet;
      }
    },
    async fetchBillingPortalLink() {
      this.showLoader = true;
      const billingPortalLinkRequest = await HapiService.retrieveBillingPortalLink();
      this.billingPortalLink = billingPortalLinkRequest.data.billingPortalLink;
      this.showLoader = false;
    },
    async onBillingPortalLinkClick() {
      // we assume that the user has billing details now
      // and come back to this flow if that turns out to be false
      this.wallet = {
        ...this.wallet,
        ...{
          hasBillingDetails: true
        }
      };
    }
  },
  async mounted() {
    await this.fetchWallet();
  },
  created: function() {
    window.addEventListener("message", this.onWindowMessage);
  },
  destroyed: function() {
    window.removeEventListener("message", this.onWindowMessage);
  }
};
</script>

<style scoped>
.billing-portal-link {
  margin-top: 0.5rem;
}

.billing-portal-link a {
  display: block;
}
</style>
